import { LoanStatusType } from '../common/LoanConstants';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { OnOpenLoanDetail, onActionCellRender } from '../common/LoanFunctions';
import { LoanPropertyCommitOrApprovalColumn } from '../../common/components/LoanPropertyCommitOrApprovalColumn';
import { LoanRepaidIndicatorColumn } from '../common/components/LoanRepaidIndicatorColumn';
import { useLocation } from 'react-router-dom';
import { onStructureTypeCellRender } from '../common/functions/onStructureTypeCellRender';

const PortfolioLoanTable = ({ loans, statusId, showStructureType, showPropertyStatus }) => {
    const location = useLocation();
    const onAddressCellRender = (e) => {
        if (e.data.address.street2) {
            return e.data.address.street1 + ', ' + e.data.address.street2;
        } else {
            return e.data.address.street1;
        }
    };

    if (!loans || loans.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={loans}
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={false}
            allowColumnResizing={true}
            width={'80%'}
            cellHintEnabled={true}
            onCellDblClick={(e) => OnOpenLoanDetail(e, location)}
        >
            <Column
                dataField='address.street1'
                caption='Address'
                cellRender={onAddressCellRender}
            />
            <Column
                dataField='propertyCity'
                caption='City'
                width={180}
            />
            <Column
                dataField='propertyState'
                caption='State'
                width={70}
            />
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={120}
            />
            {showStructureType && (
                <Column
                    dataField='structureTypeId'
                    caption='Structure Type'
                    dataType='string'
                    cellRender={onStructureTypeCellRender}
                    width={120}
                />
            )}
            {showPropertyStatus && (
                <Column
                    dataField={'propertyStatus'}
                    caption='Type'
                    width={80}
                    alignment='left'
                />
            )}
            {LoanPropertyCommitOrApprovalColumn({ statusId: statusId })}
            {statusId === LoanStatusType.Repaid && (
                <Column
                    dataField='totalRepaidAmount'
                    caption='Repaid Amt'
                    dataType='number'
                    format='currency'
                    width={110}
                    alignment={'left'}
                />
            )}
            <Column
                dataField='loanToValue'
                caption='LTV'
                dataType='number'
                format={{ type: 'percent', precision: 1 }}
                width={80}
                alignment={'left'}
            />
            {LoanRepaidIndicatorColumn({ statusId: statusId })}
            <Column
                alignment='center'
                cellRender={(e) => onActionCellRender(e, true)}
                width={50}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
                type='actions'
                fixed={true}
                fixedPosition={'right'}
            />
        </DataGrid>
    );
};

export default PortfolioLoanTable;
